const nonFieldError = Symbol('Non Field Error');
const fieldDependencies = Symbol('Field Dependencies');
const undefinedValue = Symbol('Undefined Value');
const nullValue = Symbol('Null Value'); // declare const undefindValue: unique symbol;
// declare const nullValue: unique symbol;

export { fieldDependencies, nonFieldError, nullValue, undefinedValue };
//# sourceMappingURL=types.js.map
